import { EventIconDataType, EventOptionsType, EventType, UserType } from "globals/types/models.ts";
import dayjs from "dayjs";
import { EnumLangType, EnumPlanType, EnumUserTypeType } from "globals/types/globals.ts";

export type EventImageFormValuesType = {
  orderIdx: number
  imagePath: string
  imageUrl: string
  formats: number[] | null
}

export type EventDateFormValuesType = {
  startDate: string | null
  endDate: string | null
}

export type EventFormValuesType = {
  active: boolean
  titleFr: string | null
  titleEn: string | null
  descriptionFr: string | null
  descriptionEn: string | null
  address: string | null
  city: string | null
  zipcode: string | null
  state: string | null
  country: string | null
  price: string | null
  website: string | null
  phoneNumber: string | null
  externalLink: string | null
  categoryId: number | null
  latitude: number | null
  longitude: number | null
  recurring: "monthly" | "weekly" | "bi-weekly" | "daily" | "none" | null
  dates: EventDateFormValuesType[]
  images: EventImageFormValuesType[]
  iconData: EventIconDataType | null
  creatorId?: number | null
  options?: EventOptionsType | null
}
export const getValuesFromEvent = (event: EventType): EventFormValuesType => {

  let dates: EventDateFormValuesType[] = event.dates;
  if (dates.length === 0) {
    dates = [{
      startDate: dayjs()
        .add(1, "day")
        .add(1, "hour")
        .set("minute", 0)
        .set("second", 0)
        .set("millisecond", 0)
        .format("YYYY-MM-DD HH:mm:ss"),
      endDate: dayjs()
        .add(1, "day")
        .add(2, "hour")
        .set("minute", 0)
        .set("second", 0)
        .set("millisecond", 0)
        .format("YYYY-MM-DD HH:mm:ss")
    }];//init with 1 date
  }
  return {
    active: event.active,
    titleFr: event.titleFr,
    titleEn: event.titleEn,
    descriptionFr: event.descriptionFr,
    descriptionEn: event.descriptionEn,
    address: event.address,
    city: event.city,
    zipcode: event.zipcode,
    state: event.state,
    country: event.country,
    price: event.price,
    website: event.website,
    phoneNumber: event.phoneNumber,
    externalLink: event.externalLink,
    categoryId: event.categoryId,
    latitude: event.latitude,
    longitude: event.longitude,
    dates: dates,
    images: event.images,
    iconData: event.iconData,
    recurring: event.recurring,
    creatorId: event.creatorId || null,
    options: event.options || {
      featured: false,
      size: "normal"
    }
  };
};

export type SignUpFormValuesType = {
  name: string
  email: string
  password: string
  acceptTerms: boolean
  type: EnumUserTypeType
  step: 1 | 2
}

export type UserFormValuesType = {
  name: string
  email: string
  unverifiedEmail: string | null
  acceptCommunications: boolean,
  acceptTerms: boolean,
  preferredLang: EnumLangType

  type: EnumUserTypeType

  address: string | null
  city: string | null
  zipcode: string | null
  state: string
  country: string

  billingAddress: string | null
  billingCity: string | null
  billingZipcode: string | null
  billingState: string
  billingCountry: string
  trialEndedAt: string | null

  website: string | null
  phoneNumber: string | null
  planType: EnumPlanType | null

  sameAddress: boolean
}

export const getValuesFromUser = (user: UserType): UserFormValuesType => {
  return {
    name: user.name,
    email: user.email,
    unverifiedEmail: user.unverifiedEmail,

    preferredLang: user.preferredLang,

    address: user.address,
    city: user.city,
    zipcode: user.zipcode,
    state: user.state,
    country: user.country,

    type: user.type,

    billingAddress: user.billingAddress,
    billingCity: user.billingCity,
    billingZipcode: user.billingZipcode,
    billingState: user.billingState,
    billingCountry: user.billingCountry,

    trialEndedAt: user.trialEndedAt ? dayjs.utc(user.trialEndedAt).format("YYYY-MM-DD") : null,

    website: user.website,
    phoneNumber: user.phoneNumber,
    planType: user.planType,

    acceptTerms: user.acceptTerms,
    acceptCommunications: user.acceptCommunications,

    sameAddress: user.billingAddress === user.address

  };
};
